if($('.type-detail').length){
    if($('.p-detail-inner').find('.flag.flag-discount').length>0){
     $('.p-detail-inner').find('.flag.flag-discount').html($('.p-detail-inner').find('.flag.flag-discount').html().replace(/^\s*od\s*/i, '').replace(/\s*až\s*/i, '').trim());

    }


    if($('.extended-description .detail-parameters tr:contains("Velikostni_tabulka_URL")').length){
        $('.extended-description .detail-parameters tr:contains("Velikostni_tabulka_URL")').hide();
        $('.p-info-wrapper .detail-parameters tbody').append('<tr><th colspan="2"><span class="popupButton" data-url="'+$('.extended-description .detail-parameters tr:contains("Velikostni_tabulka_URL") td').text().trim()+'">Velikostní tabulka</span></th></tr>')
    }

    $(document).on('click', '.popupButton', function(e) {
        e.preventDefault();

        var url = $(this).data('url');

        $.colorbox({
            href: url,
            iframe: true,       // pokud je to URL (např. stránka / PDF)
            width: "80%",
            height: "80%",
            maxWidth: "95%",
            maxHeight: "95%"
        });
    });
    
   $(document).ready(function () {

   



        var apiUrl = "https://php.shopcode.cz/api/kvalitniBoticky/api-related.php";
        var section = "armyshop";

        function escapeHtmlAttr(text) {
            return text
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        }

        $.ajax({
            url: apiUrl,
            type: "GET",
            data: {
                section: section,
                codes: getShoptetDataLayer('product').codes[0].code
            },
            dataType: "json",
            success: function (response) {

                if (!response.success || !response.result?.length) {
                    console.warn("API nevrátilo žádná data.");
                    return;
                }

                var data = response.result[0];
                var alternatives = data.alternatives || [];

                if (!alternatives.length) {
                    console.warn("Žádné alternativy nebyly nalezeny.");
                    return;
                }

                $(".p-info-wrapper").prepend(`
                    <div class="friendsSection">
                        <div class="h3">Barevná varianta</div>
                        <div class="inner"></div>
                    </div>
                `);

                // Seřazení podle názvu
                alternatives.sort(function (a, b) {
                    return a.name.localeCompare(b.name, 'cs');
                });

                alternatives.forEach(function (item) {

                    if (item.visibility !== "visible") return;

                    var nameEscaped = escapeHtmlAttr(item.name);

                    var isActive = (document.location.pathname === item.url)
                        ? "active"
                        : "";

                    var imageUrl = item.image
                        ? item.image.replace('/orig/', '/detail/')
                        : '/user/documents/system/no-image.jpg';

                    var detailHtml = `
                        <div class="friend ${isActive} show-tooltip"
                            data-title="${nameEscaped}"
                            data-original-title="${nameEscaped}">
                            <div class="p">
                                <div class="image">
                                    <a href="${item.url}">
                                        <img src="${imageUrl}" alt="${nameEscaped}">
                                    </a>
                                </div>
                            </div>
                        </div>
                    `;

                    $(".p-info-wrapper .friendsSection .inner").append(detailHtml);
                });

            },
            error: function (xhr, status, error) {
                console.error("Chyba při volání API:", error);
            }
        }).done(function () {
            initTooltips();
        });
    

});
    $('.p-detail-inner-header .p-code').after($('.p-detail-info a[data-testid="productCardBrandName"]').closest('div').clone())
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone());
    $('.p-image').append($('.p-detail-info .flags'));
    $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });
    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === 'Zvolte variantu'){
            $(this).text('Dle varianty')
        }
    })
    
    $('.p-info-wrapper .delivery-time').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="stockLine"></div>')
    if($('.p-info-wrapper .delivery-time').length>0){
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html())
    }
    else{
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .shipping-options'))
       
    }
  
    $('.p-info-wrapper').append('<div class="customCart"><div class="inner"></div></div>');
    $('.customCart .inner').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))


    if($('.variant-list').length){
        if(!$('#simple-variants').length){
            if($('.variant-list, .surcharge-list').length>0){
                $('.variant-list select, .surcharge-list select').each(function(){
                    if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                        var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                    }
                    else{
                        listTootip = ''
                    }
                    var optionLength = $(this).find('option').length
                    var data_parameter_id = $(this).data('parameter-id')
                    var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                    html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                    $(this).find('option').each(function(){
                        var data_value = $(this).attr('value')
                        if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                            if ($.isNumeric($(this).val())) {
                                var textsplit = $(this).text().split('+')
                                html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                                html_var += '<div class="text">'
                                if(typeof textsplit[1] === 'undefined'){
                                    html_var += textsplit[0]
                                }
                                else{
                                    html_var += textsplit[0]+' (+'+textsplit[1]+')'
                                }
                              
                                if(listTootip !== ''){
                                    if(textsplit[1] !== '0 Kč'){
                                        html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                    }
                                }
                                html_var += '</div>'
                                html_var += '</div>'
                            }
                        }
                        else{
                            if ($.isNumeric($(this).val())) {
                                var textsplit = $(this).text().split('+')
                                html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                                html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                                html_var += '</div>'
                            }
                        }
                        
                    })
                    html_var += '</div>'
                    html_var += '</div>'
                    $(this).after(html_var)
                    $(this).closest('.variant-list select, .surcharge-list select').hide()
                   $(this).closest('.variant-list span, .surcharge-list span').hide()
                  
                })
        
                var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
                for (var parentKey in necessaryVariantData) {
                    if (necessaryVariantData.hasOwnProperty(parentKey)) {
                        var variant = necessaryVariantData[parentKey];
                        $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).attr('data-notSouldOut', variant.isNotSoldOut)
                    
                    }
                }
                
            }
        }
        $(document).ready(function(){
            $(".custom-variant-wrap").each(function() {
                var $variants = $(this).find("div.variant");
                if ($variants.length === 1) {
                 $variants.addClass("active");
                }
              });
            var urlParams = new URLSearchParams(window.location.search);
            var parameterValueId = urlParams.get("parameterValueId");
            var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
            if ($divToHighlight.length > 0) {
                $divToHighlight.addClass("active");
            }
        })
        
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
}